<template>
  <div style="margin: 20px;">
    <div style="height: 70px;font-size: 14px;">
      <p align="left"><i class="el-icon-document" style="padding-right: 12px;"></i>{{shareFileName}}</p>
      <p align="left"><i class="el-icon-time" style="padding-right: 12px;"></i>分享时间：{{shareTime}} 过期时间：{{expireTime}}</p>
    </div>
    <div class="row">
      <!--<el-button :disabled="disabledDownload" size="mini" type="primary">保存到网盘</el-button>-->
      <el-button size="mini" type="primary" v-show="showCancel" @click="cancelShare" icon="el-icon-cus-cancel1">取消分享</el-button>
    </div>
    <div class="line"></div>
    <div class="block content-top">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: 12px;font-size: 12px;color: #409EFF;height: 8px;">
        <el-breadcrumb-item v-if="fileRouterList.length > 0"><a @click="returnLastFile" style="color: #409EFF;">返回上一级</a></el-breadcrumb-item>
        <el-breadcrumb-item v-if="fileRouterList.length === 0"><a>{{shareFileName}}</a></el-breadcrumb-item>
        <el-breadcrumb-item v-for="(item, idx) in fileRouterList" :key="idx"><a @click="returnFile(item)" :style="{color: item.color}">{{item.fileName}}</a></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-------------------文件列表 start----------------------->
    <el-table ref="multipleTable" :data="filesList"  @cell-mouse-enter="onHoverCellEnter" @cell-mouse-leave="onHoverCellLeave"
              @select-all="onCheckRow" :default-sort = "{prop: 'fileSize', order: 'descending'}"
              @selection-change="onCheckRow" id="app_content_file_table"
              :height="tableHeight" :style="{'width': tableWidth+'px'}" highlight-current-row @row-click="onClickRow">
      <!--<el-table-column align="left" type="selection" width="55"> </el-table-column>-->
      <el-table-column align="left" label="文件名称">
        <template slot-scope="scope">
          <div :id="scope.row.fileGuid" @mouseover="hoverFileName(scope.row)">
            <el-popover trigger="hover" :open-delay=1500>
              <p>{{ scope.row.fileName }}</p>
              <div slot="reference" class="name-wrapper">
                <el-button type="text" :style="{color: scope.row.fontColor}" @click="clickFileName(scope.row)" :icon="scope.row.icon" class="too-long user-select">{{scope.row.fileName}}</el-button>
              </div>
            </el-popover>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="left" width="70px">
        <template slot-scope="scope" v-if="scope.row.showOperateFlag">
          <div class="btn-operate">
            <el-button size="mini" type="text" class="font-size btn-tag list-btn" icon="el-icon-download" :style="{color: scope.row.iconColor}" @click="clickDownload"></el-button>
            <!--<a class="font-size btn-tag list-btn" :style="{color: scope.row.iconColor}" :href="'shareFileRequest?fileGUID='+contextMenuFile.fileGuid+'&shareGUID='+fileShare.shareGUID" target="_blank"><i class="el-icon-download"></i></a>-->
          </div>
        </template>
      </el-table-column>
      <el-table-column align="left" width="70px">
        <template slot-scope="scope" v-if="scope.row.fileDesc">
          <el-popover trigger="click">
            <p>说明: {{ scope.row.fileDesc }}</p>
            <div slot="reference" class="name-wrapper">
              <div class="btn-operate">
                <el-button type="text" size="mini" icon="el-icon-info" class="icon-more" :style="{color: scope.row.iconColor}"></el-button>
              </div>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column align="left" sortable label="大小" width="90">
        <template slot-scope="scope">
          <span>{{scope.row.fileSize}}</span>
        </template>
      </el-table-column>
      <!--<el-table-column align="left" prop="creator" label="创建人"> </el-table-column>-->
      <el-table-column align="left" prop="updateDT" sortable label="修改时间" min-width="120px"> </el-table-column>
    </el-table>
    <!-------------------文件列表 end----------------------->
    <login-dialog :dialogVisible="showLoginDialog" @closeLoginDialog="closeLoginDialog"></login-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import ct from '../../utils/constant.js'
import loginDialog from '../../components/dialog/LoginDialog.vue'
export default {
  created () {
    window.addEventListener('resize', this.resizeHandler())
  },
  mounted () {
  },
  props: ['filesList', 'fileShare'],
  components: {
    loginDialog
  },
  data () {
    return {
      checkRow: [],
      hoverRow: null,
      fileRouterList: [],
      tableHeight: this.computedHeight - 180,
      tableWidth: this.computedWidth - 300,
      contextMenuFile: {},
      clickRow: null,
      showLoginDialog: false
    }
  },
  watch: {
    'computedHeight': function (val) {
      this.tableHeight = val - 180
    },
    'computedWidth': function (val) {
      this.tableWidth = val - 320
    },
    'fileRouterList': function (val) {
      for (let i = 0; i < val.length; i++) {
        let r = val[i]
        if (i === val.length - 1) {
          r.color = '#2c3e50'
        } else {
          r.color = '#409EFF'
        }
      }
    }
  },
  methods: {
    ...mapMutations(['setFilesList', 'setTagsList', 'setRootFile', 'setCurrentDirGuid', 'setContextMenuElement',
      'setTarget', 'setCurrentFileList', 'setFileRouterList', 'setShowMoveDirDialog', 'setHrefFlag']),
    resizeHandler () {
      this.tableHeight = this.computedHeight - 180
      this.tableWidth = this.computedWidth - 320
    },
    onClickRow (row) {
      row.fontColor = '#409EFF'
      this.clickRow = row
    },
    onHoverCellEnter (row, column, cell, event) {
      this.contextMenuFile = row
      row.fontColor = '#409EFF'
      row.iconColor = '#409EFF'
      // }
    },
    onHoverCellLeave (row, column, cell, event) {
      row.fontColor = '#303133'
      row.iconColor = 'gray'
      // }
    },
    onCheckRow (sel) {
      this.checkRow = sel
    },
    clickFileName (file) {
      if (file.isDir === ct.Boolean.no) {
        this.$refs.multipleTable.toggleRowSelection(file)
        return
      }
      this.checkRow = []
      this.$emit('clickFileName', file)
      if (this.fileRouterList.filter(item => item.fileGuid === file.fileGuid).length === 0) {
        this.fileRouterList.push(file)
        this.setFileRouterList(this.fileRouterList)
      }
    },
    hoverFileName (file) {
      this.setContextMenuElement(document.getElementById(file.fileGuid))
      this.setTarget('file')
      file.fontColor = '#409EFF'
      file.iconColor = '#409EFF'
      this.contextMenuFile = file
    },
    leaveFileName (file) {
      if (this.isArrange) {
        if (!file.isChecked) {
          file.showCheckBox = false
        }
        file.fontColor = '#303133'
        file.iconColor = 'gray'
        file.showDesc = false
      }
    },
    returnFile (file) {
      this.$emit('clickFileName', file)
      this.fileRouterHandler(file)
    },
    fileRouterHandler (file) {
      let index = this.fileRouterList.indexOf(file) + 1
      let length = this.fileRouterList.length - index
      this.fileRouterList.splice(index, length)
    },
    returnLastFile () {
      // console.log('returnLastFile')
      let router = this.fileRouterList
      let len = router.length
      if (len < 2) {
        this.$emit('getSharedList')
        this.fileRouterList = []
      } else {
        let file = router[router.length - 2]
        this.$emit('clickFileName', file)
        this.fileRouterHandler(file)
      }
    },
    cancelShare () {
      this.$emit('cancelShare')
    },
    clickDownload () {
      let url_ = 'shareFileRequest?fileGUID=' + this.contextMenuFile.fileGuid + '&shareGUID=' + this.fileShare.shareGUID
      let a = document.createElement('a')
      document.body.appendChild(a)
      a.setAttribute('href', url_)
      a.click()
    },
    closeLoginDialog () {
      this.showLoginDialog = false
    }
  },
  computed: {
    ...mapState(['customerInfo', 'rootFile', 'computedHeight', 'isArrange', 'tagsList', 'srcPage', 'currentFileList', 'computedHeight', 'computedWidth', 'isAdminCustomer']),
    openDelay () {
      return 2000
    },
    shareFileName () {
      let list = this.filesList
      if (list && list.length > 0) {
        return list.length === 1 ? list[0].fileName : list[0].fileName + '等'
      }
      return ''
    },
    shareTime () {
      return this.fileShare.createDT
    },
    expireTime () {
      return this.fileShare.expireTime
    },
    showCancel () { // 用户登录
      return this.customerInfo && this.customerInfo !== null && this.fileShare.creator === this.customerInfo.customerNo && this.fileRouterList.length === 0
    },
    showDownload () {
      return this.contextMenuFile.isDir === ct.Boolean.no
    },
    disabledCancel () {
      return this.clickRow === null
    }
  }
}
</script>

<style>
  .row {
    display: flex;
    flex-direction: row;
  }

  .line {
    border-bottom: 0.5px solid gainsboro;
    width: 100%;
    margin-top: 12px;
  }

  .font-size {
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/share/SharedFiles.vue